'use client';
import { getColorScheme } from '@/utils/getColorScheme';
import { getVerticalSpacing } from '@/utils/getVerticalSpacing';
import { parseImagePosition } from '@/utils/parseImagePosition';
import Carousel from 'nuka-carousel';
import { useEffect, useState } from 'react';

export default function Reviews(props) {
    const {
        Images = [],
        Showcase,
        VerticalSpacing = 'medium',
        ColorScheme = 'light',
        ImageVariant = 'regular',
        Variant = 'default', // backward compatibility
    } = props;

    let number = '2';

    if (Showcase) {
        switch (Showcase.trim()) {
            case '4':
                number = 4;
                break;
            case '3':
                number = 3;
                break;
            case '1':
                number = 1;
                break;
            default:
                '2';
                number = 2;
                break;
        }
    }

    if (
        ColorScheme.trim() === 'primary-no-box' ||
        ColorScheme.trim() === 'secondary-no-box'
    ) {
        number = 1;
    }

    const { backgroundColor, backgroundStyle } = getColorScheme(
        ColorScheme,
        props.GradientDirection
    );

    const normalizeVariant = (val) => {
        const v = String(val || '')
            .toLowerCase()
            .trim();
        if (v.startsWith('full')) return 'full';
        return 'regular';
    };
    const variantValue = normalizeVariant(ImageVariant ?? Variant ?? 'regular');
    const isFullVariant = variantValue === 'full';
    const cellSpacing = isFullVariant ? 0 : 48;
    const withoutControls = isFullVariant;
    const pauseOnHover = isFullVariant ? false : true;
    const [slidesToShow, setSlidesToShow] = useState(number);
    const safeImages = Array.isArray(Images) ? Images : [];

    const vSpace = isFullVariant ? '' : getVerticalSpacing(VerticalSpacing);

    // Function to update the number of slides to show based on screen width
    const updateSlidesToShow = () => {
        if (window.innerWidth < 1024) {
            setSlidesToShow(1); // Show 1 slide on mobile
        } else {
            setSlidesToShow(number); // Show the original number of slides on larger screens
        }
    };

    // Update the number of slides to show when the window is resized
    useEffect(() => {
        updateSlidesToShow();
        window.addEventListener('resize', updateSlidesToShow);
        return () => {
            window.removeEventListener('resize', updateSlidesToShow);
        };
    }, [number]);

    return (
        <div
            className={`editable-component relative ${
                isFullVariant ? 'py-0 sm:py-0' : ''
            } ${backgroundColor} ${vSpace}`}
            style={backgroundStyle}
        >
            <div
                className={`mx-auto ${
                    isFullVariant ? 'w-full' : 'w-full'
                } xl:max-w-none`}
            >
                <div
                    className={`mx-auto flow-root ${
                        isFullVariant ? 'w-full' : 'w-full'
                    }`}
                >
                    <Carousel
                        renderCenterLeftControls={({
                            previousSlide,
                            previousDisabled,
                        }) => (
                            <button
                                className={`fa-solid fa-angle-left relative p-10 text-3xl text-neutral-800 opacity-30 transition-opacity duration-500 ease-in-out hover:opacity-100`}
                                onClick={previousSlide}
                                disabled={previousDisabled}
                                aria-label="Previous Slide"
                            ></button>
                        )}
                        renderCenterRightControls={({
                            nextSlide,
                            nextDisabled,
                        }) => (
                            <button
                                className={`fa-solid fa-angle-right relative p-10 text-3xl text-neutral-800 opacity-30 transition-opacity duration-500 ease-in-out hover:opacity-100`}
                                onClick={nextSlide}
                                disabled={nextDisabled}
                                aria-label="Next Slide"
                            ></button>
                        )}
                        renderBottomCenterControls={() => <div></div>}
                        cellAlign="center"
                        cellSpacing={cellSpacing}
                        className={`mx-auto ${
                            isFullVariant ? 'w-full' : 'py-8'
                        }`}
                        disableEdgeSwiping={true}
                        withoutControls={withoutControls}
                        pauseOnHover={pauseOnHover}
                        autoplay={true}
                        autoplayInterval={5000}
                        wrapAround={true}
                        slidesToShow={slidesToShow}
                    >
                        {safeImages.map((image, index) => {
                            const { x: imagePosX, y: imagePosY } =
                                parseImagePosition(image.ImagePosition);
                            return (
                                <div
                                    key={index}
                                    className={`mx-auto flex ${
                                        isFullVariant
                                            ? 'h-full min-h-[400px] sm:min-h-[600px] lg:min-h-[750px] xl:min-h-[800px] 2xl:min-h-[900px]'
                                            : 'h-[300px] md:h-[400px] xl:h-[500px]'
                                    }  ${
                                        isFullVariant
                                            ? ''
                                            : 'rounded-[min(1.5rem,var(--shape-radius))] shadow-xl'
                                    } w-full bg-cover bg-center object-cover`}
                                    style={{
                                        backgroundImage: `url(${image.ImageUrl})`,
                                        backgroundPosition: `${imagePosX}% ${imagePosY}%`,
                                    }}
                                ></div>
                            );
                        })}
                    </Carousel>
                </div>
            </div>
        </div>
    );
}
